import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Printer, Edit, Trash2, Clock, Plus } from 'lucide-react';
import OfficialPrescription from './OfficialPrescription';

export default function PrescriptionModal({ open, onClose, patient, prescription, onEdit, onDelete, onNewPrescription }) {
  const handlePrint = () => {
    window.print();
  };

  // Create portal for print content
  const printContent = open ? (
    <div className="prescription-print-container" style={{display: 'none'}}>
      <OfficialPrescription patient={patient} prescription={prescription} />
    </div>
  ) : null;

  // Format update info
  const getUpdateInfo = () => {
    if (prescription.updated_at || prescription.data_atualizacao) {
      const updateDate = new Date(prescription.updated_at || prescription.data_atualizacao);
      return updateDate.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
    return null;
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onClose}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold">Receita Médica - {patient.nome}</DialogTitle>
            <DialogDescription className="flex items-center justify-between">
              <span>Visualize, imprima, edite ou delete a receita deste paciente</span>
              {getUpdateInfo() && (
                <Badge variant="outline" className="ml-4 text-xs">
                  <Clock className="w-3 h-3 mr-1" />
                  Atualizada em: {getUpdateInfo()}
                </Badge>
              )}
            </DialogDescription>
          </DialogHeader>

          <div className="flex gap-3 mt-6">
            <Button onClick={handlePrint} className="flex-1 bg-primary text-primary-foreground hover:bg-primary/90 rounded-full h-12">
              <Printer className="w-4 h-4 mr-2" />
              Imprimir
            </Button>
            {onNewPrescription && (
              <Button onClick={onNewPrescription} variant="outline" className="flex-1 rounded-full h-12 bg-green-50 hover:bg-green-100 text-green-700 border-green-200">
                <Plus className="w-4 h-4 mr-2" />
                Nova Receita
              </Button>
            )}
            {onEdit && (
              <Button onClick={onEdit} variant="outline" className="flex-1 rounded-full h-12">
                <Edit className="w-4 h-4 mr-2" />
                Editar
              </Button>
            )}
            {onDelete && (
              <Button onClick={onDelete} variant="destructive" className="flex-1 rounded-full h-12">
                <Trash2 className="w-4 h-4 mr-2" />
                Deletar
              </Button>
            )}
          </div>

          <div className="no-print">
            <OfficialPrescription patient={patient} prescription={prescription} />
          </div>
        </DialogContent>
      </Dialog>
      
      {/* Portal to body for printing */}
      {typeof document !== 'undefined' && printContent && createPortal(printContent, document.body)}
    </>
  );
}